import { Component, OnInit, Output, EventEmitter, HostListener } from '@angular/core';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  @Output() sendDataToParent = new EventEmitter<string>();
  isHideDrawer: boolean;

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    if (event.target.innerWidth >= 992) {
      this.isHideDrawer = false;
    } else {
      this.isHideDrawer = true;
    }
  }

  constructor() { }

  ngOnInit(): void {
    if (window.innerWidth >= 992) {
      this.isHideDrawer = false;
    } else {
      this.isHideDrawer = true;
    }
  }

  // Toggle menu for drawer
  toggleMenu(): void {
    this.sendDataToParent.emit('open');
  }
}
